import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHammer,
  faBorderAll,
  faPaintRoller,
  faGripLines,
  faHouseChimney,
  faScrewdriverWrench,
  faBolt,
  faDoorOpen,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './services.css';

const servicesData = [
  {
    id: 'lumber-est',
    title: 'Lumber Estimation',
    icon: faHammer,
    description: 'Piece-by-piece lumber counts for framing, sheathing and blocking, so you order exactly what the job needs.',
    link: '/services/lumber-estimation',
  },
  {
    id: 'flooring-est',
    title: 'Flooring Estimation',
    icon: faBorderAll,
    description: 'Accurate takeoffs for tile, wood, carpet, vinyl and resilient flooring, including waste and transitions.',
    link: '/services/flooring-estimation',
  },
  {
    id: 'painting-est',
    title: 'Painting Estimation',
    icon: faPaintRoller,
    description: 'Surface-by-surface quantities for walls, ceilings, trim and exteriors, matched to the finish schedule.',
    link: '/services/painting-estimation',
  },
  {
    id: 'siding-est',
    title: 'Siding Estimation',
    icon: faGripLines,
    description: 'A complete breakdown of siding, trim, wrap and accessories measured directly from your elevations.',
    link: '/services/siding-estimation',
  },
  {
    id: 'roofing-est',
    title: 'Roofing Estimation',
    icon: faHouseChimney,
    description: 'Roof areas, pitches, flashing and accessories quantified for shingle, metal and low-slope systems.',
    link: '/services/roofing-estimation',
  },
  {
    id: 'mep-est',
    title: 'MEP Estimation',
    icon: faScrewdriverWrench,
    description: 'Detailed mechanical, electrical and plumbing takeoffs covering equipment, distribution and fittings.',
    link: '/services/mep-estimation',
  },
  {
    id: 'electrical-est',
    title: 'Electrical Estimation',
    icon: faBolt,
    description: 'Device counts, conduit and wire runs, panels and fixtures measured for confident electrical bids.',
    link: '/services/electrical-estimation',
  },
  {
    id: 'hardware-est',
    title: 'Openings & Hardware',
    icon: faDoorOpen,
    description: 'Doors, frames, glazing and hardware sets reconciled against your schedules, opening by opening.',
    link: '/services/openings-and-hardware',
  },
];

export default function Services() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <section className="services_container" aria-labelledby="services-heading">
      <div className="services_inner">
        <header className="services_heading" data-aos="fade-up">
          <span className="services_eyebrow">Our Services</span>
          <h2 id="services-heading" className="services_sub-heading">
            Estimating support for every trade
          </h2>
          <p className="services_intro">
            Precise material takeoffs and cost estimates, prepared by specialists and delivered on schedule.
          </p>
        </header>

        <div className="services_grid">
          {servicesData.map((service, index) => (
            <Link
              key={service.id}
              id={service.id}
              to={service.link}
              className="services_card"
              data-aos="fade-up"
              data-aos-duration="600"
              data-aos-delay={(index % 4) * 60}
            >
              <div className="services_card-top">
                <span className="services_icon-container" aria-hidden="true">
                  <FontAwesomeIcon className="services_item-icon" icon={service.icon} />
                </span>
                <span className="services_index" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="services_title">{service.title}</h3>
              <p className="services_description">{service.description}</p>
              <span className="services_button">
                Learn more <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
